import {
  ADD_GATE,
  ADD_GATE_FAILURE,
  ADD_GATE_SUCCESS,
  //
  DELETE_GATE,
  DELETE_GATE_FAILURE,
  DELETE_GATE_SUCCESS,
  //
  EDIT_GATE,
  EDIT_GATE_FAILURE,
  EDIT_GATE_SUCCESS,
  //
  FETCH_GATES,
  FETCH_GATES_FAILURE,
  FETCH_GATES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_BOOK_INFO,
  GET_BOOK_INFO_FAILURE,
  GET_BOOK_INFO_SUCCESS,
  TOGGLE_INVITE_VISITOR,
  //
  INVITE_VISITOR,
  INVITE_VISITOR_SUCCESS,
  INVITE_VISITOR_FAILURE,
} from "./constants";

// List
export const fetchGates = (payload, onSuccess) => ({
  type: FETCH_GATES,
  payload,
  onSuccess,
});
export const fetchGatesSuccess = (payload) => ({
  type: FETCH_GATES_SUCCESS,
  payload,
});
export const fetchGatesFailure = (payload) => ({
  type: FETCH_GATES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addGate = (payload, onSuccess) => ({
  type: ADD_GATE,
  payload,
  onSuccess,
});
export const addGateSuccess = (payload) => ({
  type: ADD_GATE_SUCCESS,
  payload,
});
export const addGateFailure = (payload) => ({
  type: ADD_GATE_FAILURE,
  payload,
});
// EDIT
export const editGate = (payload) => ({
  type: EDIT_GATE,
  payload,
});
export const editGateSuccess = (payload) => ({
  type: EDIT_GATE_SUCCESS,
  payload,
});
export const editGateFailure = (payload) => ({
  type: EDIT_GATE_FAILURE,
  payload,
});
// DELETE
export const deleteGate = (payload, onDelete) => ({
  type: DELETE_GATE,
  payload,
  onDelete,
});
export const deleteGateSuccess = (payload) => ({
  type: DELETE_GATE_SUCCESS,
  payload,
});
export const deleteGateFailure = (payload) => ({
  type: DELETE_GATE_FAILURE,
  payload,
});
// Book Info
export const getBookInfo = (payload) => ({
  type: GET_BOOK_INFO,
  payload,
});
export const getBookInfoSuccess = (payload) => ({
  type: GET_BOOK_INFO_SUCCESS,
  payload,
});
export const getBookInfoFailure = (payload) => ({
  type: GET_BOOK_INFO_FAILURE,
  payload,
});
// Toggle Invite Visitor
export const toggleInviteVisitor = (payload) => ({
  type: TOGGLE_INVITE_VISITOR,
  payload,
});
// Invite Visitor
export const inviteVisitor = (payload, onSuccess) => ({
  type: INVITE_VISITOR,
  payload,
  onSuccess,
});
export const inviteVisitorSuccess = (payload) => ({
  type: INVITE_VISITOR_SUCCESS,
  payload,
});
export const inviteVisitorFailure = (payload) => ({
  type: INVITE_VISITOR_FAILURE,
  payload,
});
